import { api } from "api/api";
import { AxiosError } from "axios";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class ProdutoService implements BaseServiceCadastros<Produto> {
    

    pesquisar(page: Pageable, filter?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/produto/pesquisar`;
            if (filter) {
                url += getFilters(filter)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: string | number) {
        return new Promise<Produto>((resolve, reject): void => {
            api
                .get(`/produto/consultar/${id}`)
                .then(response => {
                    let produto: Produto = response.data;
                    produto.componentes.forEach((componente) => {
                        componente.key = generateKey();
                    });
                    produto.operacoes.forEach((operacao) => {
                        operacao.key = generateKey();
                    });

                    resolve(produto)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(produto: Produto) {
        return new Promise<Produto>((resolve, reject): void => {
            let url = `/produto/incluir`;
            api
                .post(url, JSON.stringify(produto))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(produto: Produto) {
        return new Promise<Produto>((resolve, reject): void => {
            api
                .put(`/produto/editar`, JSON.stringify(produto))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: string | number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/produto/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioListagem(filter?: DataTableFilterMeta | null) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/produto/report/listagem`;
            if (filter) {
                url += getFilters(filter)
            }
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }


    familias() {
        return new Promise<Array<FamiliaProduto>>((resolve, reject): void => {
            api
                .get(`/produto/familias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    origens() {
        return new Promise<Array<OrigemProduto>>((resolve, reject): void => {
            api
                .get(`/produto/origens`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    roteiros() {
        return new Promise<Array<any>>((resolve, reject): void => {
            api
                .get(`/produto/roteiros`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    estagios(roteiroId: number) {
        return new Promise<Array<any>>((resolve, reject): void => {
            api
                .get(`/produto/estagios/${roteiroId}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    materiasPrimas() {
        return new Promise<Array<any>>((resolve, reject): void => {
            api
                .get(`/produto/materiasPrimas`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getAllWithComponentes() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/produto/comComponentes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    planosInspecao(fase: string) {
        return new Promise<Array<PlanoInspecao>>((resolve, reject): void => {
            api
                .get(`/produto/planosInspecao/${fase}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    operacoes() {
        return new Promise<Array<OperacaoProducao>>((resolve, reject): void => {
            api
                .get(`/produto/operacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo() {
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/produto/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }


    getTipoProduto(status: string): string {

        if (status === 'COMPRADO') {
            return 'Comprado';
        } else if (status === 'PRODUZIDO') {
            return 'Produzido';
        } else if (status === 'AMBOS') {
            return 'Ambos';
        }

        return '';
    }

    getTiposProduto(): any[] {
        return [
            { label: 'Comprado', value: 'COMPRADO' },
            { label: 'Produzido', value: 'PRODUZIDO' },
            { label: 'Ambos', value: 'AMBOS' }
        ];
    }

    getUnidadesMedida(): any[] {
        return [
            { label: 'Unidade', value: 'UN' },
            { label: 'Quilograma', value: 'KG' },
            { label: 'Litro', value: 'LT' },
            { label: "Pacote", value: "PC" }
        ];
    }

    getOrigensMercadoria() {
        return [
            { label: "0 - Nacional", value: "NACIONAL" },
            { label: "1 - Estrangeira - importação direta", value: "ESTRANGEIRA_IMPORTACAO_DIRETA" },
            { label: "2 - Estrangeira - adquirida no mercado interno", value: "ESTRANGEIRA_MERCADO_INTERNO" },
            { label: "3 - Nacional - conteúdo de importação superior a 40%", value: "NACIONAL_CONTEUDO_IMPORTACAO_SUPERIOR_40" },
            { label: "4 - Nacional - processos produtivos básicos", value: "NACIONAL_PROCESSOS_BASICOS" },
            { label: "5 - Nacional - conteúdo de importação até 40%", value: "NACIONAL_CONTEUDO_IMPORTACAO_INFERIOR_IGUAL_40" },
            { label: "6 - Estrangeira - importação direta sem similar nacional", value: "ESTRANGEIRA_IMPORTACAO_DIRETA_SEM_SIMILAR" },
            { label: "7 - Estrangeira - adquirida no mercado interno sem similar nacional", value: "ESTRANGEIRA_MERCADO_INTERNO_SEM_SIMILAR" },
            { label: "8 - Nacional - conteúdo de importação superior a 70%", value: "NACIONAL_CONTEUDO_IMPORTACAO_SUPERIOR_70" }
        ];
    }

}

export default ProdutoService;
